// extracted by mini-css-extract-plugin
export default {"container":"PackagerOrder_container__fK+HN","heading":"PackagerOrder_heading__y4Kqh"};